import React, { useEffect, useMemo, useState } from 'react';
import styles from './UIGameHelpChatLogsButton.module.scss';
import clsx from 'clsx';
import { ModeSettingEnum } from '@colonist/types';
import IconChat from '@static/images/icon_chat.svg';
import IconLog from '@static/images/icon_log.svg';
import IconRushInfo from '@static/images/icon_rushinfo.svg';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { RUSH_INTRO_VISIBLE_FOR_FIRST_N_GAMES } from '../../UIGameFeeds/UIGameRushIntro/UIGameRushIntroConstants.ts';
const ChatLogsButton = ({ icon, isSelected, isBubbleVisible, onClick })=>/*#__PURE__*/ React.createElement("div", {
        onClick: onClick,
        className: clsx(styles.buttonContainer, {
            [styles.selected]: isSelected,
            [styles.bubble]: isBubbleVisible
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.icon
    }, /*#__PURE__*/ React.createElement("img", {
        src: icon
    })));
export const UIGameHelpOpenChatLogsButton = ({ rushGamesPlayed, feedsPortraitVisibility, setFeedsPortraitVisibility })=>{
    const gameChatState = useGameStore((state)=>state.gameState.gameChatState);
    const modeSetting = useGameStore((state)=>state.gameSettings.modeSetting);
    const sendUserAccessedChatAnalytics = useGameStore((state)=>state.gameAnalytics.sendUserAccessedChatAnalytics);
    const sendUserAccessedLogAnalytics = useGameStore((state)=>state.gameAnalytics.sendUserAccessedLogAnalytics);
    const [numberOfReadMessages, setNumberOfReadMessages] = useState(0);
    const numberOfMessages = useMemo(()=>Object.keys(gameChatState).length, [
        gameChatState
    ]);
    const isChatBubbleVisible = numberOfMessages > numberOfReadMessages;
    const isOpenSettings = useGameStore((state)=>state.gameUserSettings.isOpenSettings);
    const isPaused = useGameStore((state)=>state.gamePause.isPaused);
    useEffect(()=>{
        if (isOpenSettings === true || isPaused === true) {
            setFeedsPortraitVisibility('none');
        }
    }, [
        isOpenSettings,
        isPaused
    ]);
    useEffect(()=>{
        if (feedsPortraitVisibility === 'chat') {
            setNumberOfReadMessages(numberOfMessages);
        }
    }, [
        numberOfMessages,
        feedsPortraitVisibility
    ]);
    const handleChatClick = ()=>{
        const shouldOpen = feedsPortraitVisibility !== 'chat';
        if (shouldOpen) {
            sendUserAccessedChatAnalytics(modeSetting);
        }
        setFeedsPortraitVisibility(shouldOpen ? 'chat' : 'none');
        setNumberOfReadMessages(numberOfMessages);
    };
    const handleLogClick = ()=>{
        const shouldOpen = feedsPortraitVisibility !== 'log';
        if (shouldOpen) {
            sendUserAccessedLogAnalytics(modeSetting);
        }
        setFeedsPortraitVisibility(shouldOpen ? 'log' : 'none');
    };
    const isRushGame = modeSetting == ModeSettingEnum.ColonistRush4P;
    const isRushButtonVisible = isRushGame && rushGamesPlayed < RUSH_INTRO_VISIBLE_FOR_FIRST_N_GAMES;
    const handleRushClick = ()=>{
        const shouldOpen = feedsPortraitVisibility !== 'rush';
        setFeedsPortraitVisibility(shouldOpen ? 'rush' : 'none');
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, isRushButtonVisible && /*#__PURE__*/ React.createElement(ChatLogsButton, {
        icon: IconRushInfo,
        isSelected: feedsPortraitVisibility === 'rush',
        isBubbleVisible: false,
        onClick: handleRushClick
    }), /*#__PURE__*/ React.createElement(ChatLogsButton, {
        icon: IconLog,
        isSelected: feedsPortraitVisibility === 'log',
        isBubbleVisible: false,
        onClick: handleLogClick
    }), /*#__PURE__*/ React.createElement(ChatLogsButton, {
        icon: IconChat,
        isSelected: feedsPortraitVisibility === 'chat',
        isBubbleVisible: isChatBubbleVisible,
        onClick: handleChatClick
    }));
};
